var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardTog(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.648,
    height: 16.648,
    viewBox: "0 0 16.648 16.648",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard_-_tog",
    "data-name": "Dashboard - tog",
    transform: "translate(-116.736 -165.302)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "space_dashboard_FILL1_wght400_GRAD0_opsz48_5_",
    "data-name": "space_dashboard_FILL1_wght400_GRAD0_opsz48 (5)",
    d: "M7.387,22.648A1.422,1.422,0,0,1,6,21.261V7.387A1.422,1.422,0,0,1,7.387,6h6.243V22.648Zm7.631,0V14.3h7.631v6.96a1.422,1.422,0,0,1-1.387,1.387Zm0-9.735V6h6.243a1.422,1.422,0,0,1,1.387,1.387v5.526Z",
    transform: "translate(110.736 159.302)",
    fill: "#66939e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardTog);
export default __webpack_public_path__ + "static/media/dashboard_tog.0994fee95bf09e5ddc048c2e40e01225.svg";
export { ForwardRef as ReactComponent };